import { render, staticRenderFns } from "./design_disclosure.vue?vue&type=template&id=38691816"
import script from "./design_disclosure.vue?vue&type=script&lang=js"
export * from "./design_disclosure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports